import { ApplicantsList } from "Modules/Core/Applicants/ApplicantsList/ApplicantsList";

export const ApplicantsWrapper = () => {

    return (<>
        <ApplicantsList />
    </>);
};